import { Button } from "antd";
import { useCallback, useRef } from "react";
import * as XLSX from 'xlsx';
import { CloudDownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import moment from "moment";

export default function Table2XLSX({ month, dataSource = [], shopInfo }) {
    const { t } = useTranslation()
    const tableRef = useRef(null);

    /* Callback invoked when the button is clicked */
    const xport = useCallback(async () => {
        /* Create worksheet from HTML DOM TABLE */
        const table = tableRef?.current;
        const wb = XLSX.utils.table_to_book(table);

        /* Export to file (start a download) */
        XLSX.writeFile(wb, `${t('inventoryInMonth', { month })}.xlsx`);
    }, []);

    return (<>
        <table ref={tableRef} style={{ display: 'none' }} >
            <tbody>
                <tr style={{ backgroundColor: 'red' }}>
                    <td rowSpan={2}>{t('day')}</td>
                    <td rowSpan={2}>{t('dow')}</td>
                    <td colSpan="3">{t('rice')}</td>
                    <td colSpan="3">{`${t('fishSalmon')} (${t('piece')})`}</td>
                    <td colSpan="3">{`${t('fishTuna')} (${t('piece')})`}</td>
                </tr>
                <tr>
                    <td>{t('use')}</td>
                    <td>{t('qsl')}</td>
                    <td>{t('inventory')}</td>
                    <td>{t('use')}</td>
                    <td>{t('qsl')}</td>
                    <td>{t('inventory')}</td>
                    <td>{t('use')}</td>
                    <td>{t('qsl')}</td>
                    <td>{t('inventory')}</td>
                </tr>
                {
                    dataSource.map((row, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{t(moment(row.date).format('dddd'))}</td>
                                <td>{row?.rice?.used}</td>
                                <td>{row?.rice?.qsl}</td>
                                <td>{row?.rice?.inventory}</td>
                                <td>{row?.salmon?.used}</td>
                                <td>{row?.salmon?.qsl}</td>
                                <td>{row?.salmon?.inventory}</td>
                                <td>{row?.tuna?.used}</td>
                                <td>{row?.tuna?.qsl}</td>
                                <td>{row?.tuna?.inventory}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
        <Button type='primary' size="large" icon={<CloudDownloadOutlined />} onClick={xport}>{t('exportExcel')}</Button>
    </>);
}